import { createContext } from "react";

export const EmpleadosContext = createContext()
export const EmpleadosFormContext = createContext()
export const EmpleadosReportContext = createContext()